import classNames from 'classnames';

import { setupForDark } from '@theme';

function SingleChoiceStateIcon({
  size = 36,
  className = '',
  selected = false,
  disabled = false,
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  selected?: boolean;
  disabled?: boolean;
  onClick?: (event) => void;
}) {
  let els = <></>;
  if (!selected && !disabled) {
    els = (
      <circle
        cx='11.9995'
        cy='12'
        r='9.5'
        className={setupForDark('stroke-toggle-btn-unselected')}
        fill='none'
      />
    );
  } else if (selected && !disabled) {
    els = (
      <>
        <circle cx='11.9995' cy='12' r='7' className={setupForDark('fill-toggle-btn-selected')} />
        <circle
          cx='11.9995'
          cy='12'
          r='9.25'
          strokeWidth='1.5'
          className={setupForDark('stroke-toggle-btn-selected')}
        />
      </>
    );
  } else if (!selected && disabled) {
    els = (
      <circle
        cx='11.9995'
        cy='12'
        r='9.5'
        className={setupForDark('stroke-toggle-btn-unselected-disabled')}
        fill='none'
      />
    );
  } else if (selected && disabled) {
    els = (
      <>
        <circle
          cx='11.9995'
          cy='12'
          r='7'
          className={classNames(setupForDark('fill-toggle-btn-selected-disabled'))}
        />
        <circle
          cx='11.9995'
          cy='12'
          r='9.25'
          strokeWidth='1.5'
          fill='none'
          className={classNames(setupForDark('stroke-toggle-btn-selected-disabled'))}
        />
      </>
    );
  }

  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        stroke='none'
        fill='none'
      >
        {els}
      </svg>
    </span>
  );
}

export default SingleChoiceStateIcon;
